export const PRACTICE_AREAS = [
  {
    id: "corporate",
    en: { title: "Corporate & Commercial", tag: "Boardroom counsel" },
    ar: { title: "الشركات والتجاري", tag: "استشارات مجلس الإدارة" },
    summary_en:
      "M&A, joint ventures, financings, and day-to-day commercial counsel under Kuwait Companies Law No. 1 of 2016. We advise founders, GCC family groups, and inbound investors on structuring, governance, and shareholder agreements that survive Kuwaiti judicial scrutiny.",
    summary_ar:
      "الاندماجات والاستحواذات والمشاريع المشتركة والتمويلات والمشورة التجارية اليومية وفقاً لقانون الشركات الكويتي رقم 1 لسنة 2016. نقدّم المشورة للمؤسسين والمجموعات العائلية الخليجية والمستثمرين الوافدين في الهيكلة والحوكمة واتفاقيات المساهمين التي تصمد أمام التدقيق القضائي الكويتي.",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    id: "litigation",
    en: { title: "Litigation & Arbitration", tag: "When stakes are high" },
    ar: { title: "التقاضي والتحكيم", tag: "عندما تكون المخاطر عالية" },
    summary_en:
      "Complex commercial disputes before the Kuwait Court of First Instance, Court of Appeal, and Court of Cassation, plus institutional arbitration under the CSTR, ICC, and DIAC.",
    summary_ar:
      "النزاعات التجارية المعقدة أمام محاكم الكويت بدرجاتها الثلاث — أول درجة والاستئناف والتمييز — والتحكيم المؤسسي أمام مركز الكويت للتحكيم التجاري وغرفة التجارة الدولية ومركز دبي للتحكيم.",
    span: "lg:col-span-5 lg:row-span-1",
  },
  {
    id: "real-estate",
    en: { title: "Real Estate", tag: "Land to lease" },
    ar: { title: "العقارات", tag: "من الأرض إلى الإيجار" },
    summary_en:
      "Acquisitions, developments, leasing, and real-estate registry title checks under Decree-Law 74 of 1979 (foreign-ownership restrictions) and Rent Law 35/1978.",
    summary_ar:
      "الاستحواذات والتطوير والتأجير وفحص الملكية لدى التسجيل العقاري وفقاً للمرسوم بقانون 74 لسنة 1979 (قيود تملك الأجانب) وقانون إيجار العقارات رقم 35 لسنة 1978.",
    span: "lg:col-span-5 lg:row-span-1",
  },
  {
    id: "family",
    en: { title: "Family & Personal Status", tag: "Discreet, considered" },
    ar: { title: "الأحوال الشخصية والأسرة", tag: "متحفظة ومدروسة" },
    summary_en:
      "Marriage contracts, mahr drafting, divorce, custody, and inheritance under the Personal Status Law No. 51 of 1984 — handled with discretion and a sensitivity to GCC family structures.",
    summary_ar:
      "عقود الزواج وصياغة المهر والطلاق والحضانة والميراث وفقاً لقانون الأحوال الشخصية رقم 51 لسنة 1984 — تعامل بتحفّظ ومراعاة للهياكل العائلية الخليجية.",
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    id: "criminal",
    en: { title: "Criminal Defense", tag: "Rigorous, principled" },
    ar: { title: "الدفاع الجزائي", tag: "حازم ومنهجي" },
    summary_en:
      "White-collar and personal defence under the Kuwaiti Penal Code (Law 16 of 1960), the Code of Criminal Procedure, and the Cybercrime Law (No. 63 of 2015) — from the first 24 hours through Cassation.",
    summary_ar:
      "الدفاع الجزائي في جرائم الياقات البيضاء والجرائم الشخصية وفقاً لقانون الجزاء الكويتي (16 لسنة 1960) وقانون الإجراءات والمحاكمات الجزائية وقانون مكافحة جرائم تقنية المعلومات (63 لسنة 2015) — من الـ24 ساعة الأولى حتى التمييز.",
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    id: "ip",
    en: { title: "Labour & Employment", tag: "End-of-service & beyond" },
    ar: { title: "العمل والاستخدام", tag: "نهاية الخدمة وما يليها" },
    summary_en:
      "Employment contracts, end-of-service computations, and termination disputes under Kuwait Labour Law No. 6 of 2010 — for both private-sector employers and senior employees.",
    summary_ar:
      "عقود العمل واحتساب نهاية الخدمة ونزاعات الإنهاء وفقاً لقانون العمل الكويتي رقم 6 لسنة 2010 — لأصحاب الأعمال في القطاع الخاص وكبار الموظفين على حد سواء.",
    span: "lg:col-span-4 lg:row-span-1",
  },
];

export const TEAM = [
  {
    name_en: "Abdullatif Sami Aldakheel",
    name_ar: "عبداللطيف سامي الدخيل",
    role_en: "CEO & Partner",
    role_ar: "الرئيس التنفيذي والشريك",
    focus_en: "Corporate Strategy & Litigation",
    focus_ar: "الاستراتيجية المؤسسية والتقاضي",
    bio_en:
      "Abdullatif leads the firm's corporate and litigation departments. His practice spans M&A and shareholder disputes under the Kuwait Companies Law, complex commercial litigation before the Court of Cassation, and white-collar criminal defence. He represents Kuwaiti family groups, GCC institutional investors, and inbound multinationals on their highest-stakes matters.",
    bio_ar:
      "يقود عبداللطيف قسمَي الشركات والتقاضي في المكتب. تمتد ممارسته من الاندماجات والاستحواذات ونزاعات المساهمين بموجب قانون الشركات الكويتي، إلى التقاضي التجاري المعقد أمام محكمة التمييز، والدفاع في الجرائم المالية والاقتصادية. يمثّل المجموعات العائلية الكويتية والمستثمرين المؤسسيين الخليجيين والشركات متعددة الجنسيات الوافدة في قضاياهم الأكثر حساسية.",
    photo:
      "https://customer-assets.emergentagent.com/job_legal-group-site/artifacts/n5m1fp20_ChatGPT%20Image%20May%208%2C%202026%2C%2004_51_16%20PM.png",
  },
  {
    name_en: "Eslam Alkhamisi",
    name_ar: "إسلام الخميسي",
    role_en: "Senior Legal Consultant",
    role_ar: "مستشار قانوني أول",
    focus_en: "Advisory, Compliance & Personal Status",
    focus_ar: "الاستشارات والامتثال والأحوال الشخصية",
    bio_en:
      "Eslam advises on regulatory compliance, employment under Labour Law No. 6 of 2010, and personal status matters under Law No. 51 of 1984. His authoritative timing schedules for opposition, appeal, and cassation form the procedural backbone of the firm's litigation practice. Clients value his ability to translate dense statutory text into practical, decision-ready guidance.",
    bio_ar:
      "يقدّم إسلام الاستشارات في مجالات الامتثال التنظيمي وقانون العمل رقم 6 لسنة 2010 والأحوال الشخصية وفقاً للقانون رقم 51 لسنة 1984. وجداوله المرجعية لمواعيد المعارضة والاستئناف والتمييز تشكّل العمود الفقري الإجرائي لممارسة المكتب في التقاضي. يقدّر العملاء قدرته على ترجمة النصوص التشريعية الكثيفة إلى توجيهات عملية جاهزة لاتخاذ القرار.",
    photo:
      "https://customer-assets.emergentagent.com/job_legal-group-site/artifacts/0ix16xbj_ChatGPT%20Image%20May%208%2C%202026%2C%2004_24_09%20PM.png",
  },
  {
    name_en: "Tawfeeq Ahmed",
    name_ar: "توفيق أحمد",
    role_en: "Head of Judicial Liaison",
    role_ar: "رئيس الاتصال القضائي",
    focus_en: "Court & Government Liaison",
    focus_ar: "التواصل مع المحاكم والجهات الحكومية",
    bio_en:
      "Tawfeeq runs the firm's court and government liaison desk: filing, service, follow-up, and coordination with the Ministry of Justice, the Public Prosecution, and the cadastral and commercial registries. His operational discipline ensures that procedural deadlines are met to the day, every day.",
    bio_ar:
      "يدير توفيق مكتب التواصل القضائي والحكومي للمكتب: قيد الدعاوى والإعلانات والمتابعة والتنسيق مع وزارة العدل والنيابة العامة والسجلين العقاري والتجاري. ينعكس انضباطه التشغيلي في احترام كل ميعاد إجرائي إلى اليوم، كل يوم.",
    photo:
      "https://customer-assets.emergentagent.com/job_legal-group-site/artifacts/qxi9nb9b_ChatGPT%20Image%20May%208%2C%202026%2C%2004_24_19%20PM.png",
  },
  {
    name_en: "Abdulaziz Walid Khalid Almathkour",
    name_ar: "عبدالعزيز وليد خالد المذكور",
    role_en: "Lawyer",
    role_ar: "محامي",
    focus_en: "Litigation & Legal Research",
    focus_ar: "التقاضي والبحث القانوني",
    bio_en:
      "Abdulaziz supports the firm's litigation practice across civil, commercial, and personal-status matters before the Court of First Instance and the Court of Appeal. His work focuses on case preparation, statutory research under Kuwaiti law, and drafting pleadings and legal memoranda, contributing the rigour and precision the firm's clients expect on every file.",
    bio_ar:
      "يدعم عبدالعزيز ممارسة التقاضي في المكتب في القضايا المدنية والتجارية والأحوال الشخصية أمام محكمة أول درجة ومحكمة الاستئناف. يتركّز عمله على إعداد القضايا والبحث في النصوص التشريعية الكويتية، وصياغة المذكرات واللوائح القانونية، مساهماً بالدقة والصرامة التي يتوقعها عملاء المكتب في كل ملف.",
    photo:
      "https://customer-assets.emergentagent.com/job_legal-group-site/artifacts/idwt4g88_ChatGPT%20Image%20May%2023%2C%202026%2C%2002_20_29%20AM.png",
  },
];

export const MEDIA = {
  hero:
    "https://static.prod-images.emergentagent.com/jobs/8b52f9aa-0fe5-459e-89b1-a0cc320ddaf2/images/ad3d472dd135b979bd8c61f1cfe66d8693bceeca54ea4c2aca37c87048c822f6.png",
  scales:
    "https://static.prod-images.emergentagent.com/jobs/8b52f9aa-0fe5-459e-89b1-a0cc320ddaf2/images/5ac54525785752513b6a60235d6785c2a6fc1253c3199b256bb25f4db511e7e9.png",
  office1:
    "https://customer-assets.emergentagent.com/job_legal-group-site/artifacts/p60tyiuq_ChatGPT%20Image%20May%2023%2C%202026%2C%2002_08_49%20AM.png",
  office2:
    "https://customer-assets.emergentagent.com/job_legal-group-site/artifacts/qx6cu7d6_ChatGPT%20Image%20May%2023%2C%202026%2C%2002_11_01%20AM.png",
  handshake:
    "https://images.unsplash.com/photo-1758520144427-ddb02ac74e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3NzgxNDg3MzB8MA&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { v: "9+", en: "Years of experience", ar: "سنوات من الخبرة" },
  { v: "2000+", en: "Cases handled", ar: "قضية" },
  { v: "6+", en: "Countries advised", ar: "دول قُدّمت لها الاستشارة" },
  { v: "6", en: "Practice areas", ar: "مجالات ممارسة" },
];

export const CLIENT_LOGOS = [
  "RAPRIME",
  "COPENHAGEN",
  "GCC SERVICE",
  "JAGUAR DELIVERY",
  "DEVON",
];
